import {
    NOTIFICATION_GET_FAIL,
    NOTIFICATION_GET_REQUEST,
    NOTIFICATION_GET_SUCCESS,
    NOTIFICATION_LIST_FAIL,
    NOTIFICATION_LIST_REQUEST,
    NOTIFICATION_LIST_RESET,
    NOTIFICATION_LIST_SUCCESS,
    NOTIFICATION_READ_FAIL,
    NOTIFICATION_READ_REQUEST,
    NOTIFICATION_READ_RESET,
    NOTIFICATION_READ_SUCCESS
} from '../constants/notificationConstants'

export const notificationListReducer = (state = { notifications: [] }, action) => {
    switch (action.type) {
        case NOTIFICATION_LIST_REQUEST:
            return { loading: true };
        case NOTIFICATION_LIST_SUCCESS:
            return { loading: false, notifications: action.payload }
        case NOTIFICATION_LIST_FAIL:
            return { loading: false, error: action.payload }
        case NOTIFICATION_LIST_RESET:
            return { loading: false, notifications: [] }
        default:
            return state;
    }
}

export const notificationDetailReducer = (state = { notifications: [] }, action) => {
    switch (action.type) {
        case NOTIFICATION_GET_REQUEST:
            return { loading: true };
        case NOTIFICATION_GET_SUCCESS:
            return { loading: false, notificationDet: action.payload }
        case NOTIFICATION_GET_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

export const notificationReadReducer = (state = { notifications: [] }, action) => {
    switch (action.type) {
        case NOTIFICATION_READ_REQUEST:
            return { loading: true };
        case NOTIFICATION_READ_SUCCESS:
            return { loading: false, success: action.payload }
        case NOTIFICATION_READ_FAIL:
            return { loading: false, error: action.payload }
        case NOTIFICATION_READ_RESET:
            return {}
        default:
            return state;
    }
}